<template>
  <div class="privacy-page">
    <div class="content-section">
      <h2>{{ t({ fr: 'Protection des données', en: 'Data protection' }) }}</h2>

      <div class="privacy-intro">
        <p class="intro-text">{{ t({
          fr: "AECOM s'engage à protéger la confidentialité et la sécurité des données soumises dans le cadre de l'inventaire pancanadien des ouvrages de protection contre les inondations, conformément aux lois canadiennes applicables.",
          en: 'AECOM is committed to protecting the confidentiality and security of the data submitted for the pan-Canadian inventory of flood-protection structures, in accordance with applicable Canadian laws.'
        }) }}</p>
      </div>

      <div class="data-collection">
        <h3>{{ t({ fr: 'Données recueillies', en: 'Data collected' }) }}</h3>
        <ul class="data-types">
          <li>{{ t({ fr: "Coordonnées de la personne-ressource (nom, courriel, organisation).", en: 'Contact person details (name, email, organization).' }) }}</li>
          <li>{{ t({ fr: "Métadonnées et conditions de licence des jeux de données.", en: 'Metadata and licensing conditions of the datasets.' }) }}</li>
          <li>{{ t({ fr: "Fichiers géospatiaux et documents que vous téléversez.", en: 'Geospatial files and documents you upload.' }) }}</li>
        </ul>
      </div>

      <div class="data-protection">
        <h3>{{ t({ fr: 'Sécurité des données', en: 'Data security' }) }}</h3>
        <ul class="security-list">
          <li>{{ t({ fr: "Chiffrement en transit (HTTPS) et téléversement direct sécurisé vers un stockage objet compatible S3.", en: 'Encryption in transit (HTTPS) and secure direct upload to S3-compatible object storage.' }) }}</li>
          <li>{{ t({ fr: "Accès restreint aux spécialistes de données autorisés d'AECOM et à RNCan.", en: "Access restricted to AECOM's authorized data specialists and NRCan." }) }}</li>
          <li>{{ t({ fr: "Chaque soumission possède un identifiant unique et est journalisée.", en: 'Each submission has a unique identifier and is logged.' }) }}</li>
        </ul>
      </div>

      <div class="data-usage">
        <h3>{{ t({ fr: 'Utilisation et licence', en: 'Use and licensing' }) }}</h3>
        <p>{{ t({
          fr: "L'utilisation, la modification, la diffusion et la redistribution de vos données sont régies par les autorisations que vous accordez dans le formulaire (section Licence) et par toute restriction particulière que vous y indiquez. Toute licence existante que vous fournissez est respectée.",
          en: 'The use, modification, dissemination and redistribution of your data are governed by the authorizations you grant in the form (Licence section) and by any specific restriction you state there. Any existing licence you provide is respected.'
        }) }}</p>
      </div>

      <div class="contact-privacy">
        <h3>{{ t({ fr: 'Questions', en: 'Questions' }) }}</h3>
        <p>{{ t({
          fr: "Pour toute question sur la protection des données, écrivez à",
          en: 'For any question about data protection, contact'
        }) }} <a href="mailto:flood_defense_inondation@aecom.com">flood_defense_inondation@aecom.com</a>.</p>
      </div>

      <StartSurveyButton :showBackButton="true" />
    </div>
  </div>
</template>

<script>
import StartSurveyButton from '../components/StartSurveyButton.vue'
import { t } from '../i18n/index.js'

export default {
  name: 'PrivacyPage',
  components: { StartSurveyButton },
  methods: { t }
}
</script>

<style scoped>
.privacy-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 30px 20px;
  line-height: 1.6;
}

.content-section {
  background: white;
  border-radius: 8px;
  padding: 40px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

h2 {
  color: var(--aecom-midnight-teal);
  font-size: 1.7em;
  text-align: center;
  border-bottom: 3px solid var(--aecom-lime-green);
  padding-bottom: 15px;
  margin: 0 0 10px 0;
}

h3 {
  color: var(--aecom-earth-green);
  font-size: 1.35em;
  margin: 30px 0 15px 0;
  border-left: 4px solid var(--aecom-lime-green);
  padding-left: 15px;
}

p {
  margin-bottom: 15px;
  color: #333;
  text-align: justify;
}

.intro-text {
  font-size: 1.05em;
  background: linear-gradient(135deg, rgba(0, 135, 104, 0.1) 0%, rgba(174, 204, 83, 0.1) 100%);
  padding: 20px;
  border-radius: 8px;
  border-left: 4px solid var(--aecom-earth-green);
  margin-bottom: 30px;
}

.data-types, .security-list {
  background-color: #f8f9fa;
  padding: 20px 20px 20px 30px;
  border-radius: 6px;
  margin: 15px 0;
  border-left: 4px solid var(--aecom-earth-green);
  list-style: none;
}

.data-types li, .security-list li {
  margin: 12px 0;
  padding-left: 10px;
  position: relative;
}

.data-types li::before, .security-list li::before {
  content: "•";
  color: var(--aecom-earth-green);
  font-weight: bold;
  position: absolute;
  left: -10px;
  font-size: 1.3em;
}

a {
  color: var(--aecom-earth-green);
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .content-section {
    padding: 24px;
  }
}
</style>
